export const translations = {
  en: {
    // Nav
    nav: {
      packages: "Packages",
      howItWorks: "How It Works",
      contact: "Contact",
      about: "About Us",
    },
    // Hero
    hero: {
      headline: "Get a Professional Website for Your Business",
      subheadline: "We create modern websites for local businesses – simple, affordable and without risk.",
      cta: "See your website before you decide.",
      primaryBtn: "Request Your Free Website Demo",
      secondaryBtn: "Book a Free Consultation",
      happyBusinesses: "Happy Businesses",
    },
    // Contact Person
    contactPerson: {
      title: "Your Personal Contact",
      name: "Emna Sayed",
      position: "Project & Client Manager",
      description: "Emna Sayed is your direct contact person. She will personally explain everything to you and help you choose the best solution for your business.",
    },
    // Lead Hook
    leadHook: {
      title: "Why Request a Free Demo Website?",
      badge: "Zero Risk",
      benefits: [
        "No upfront payment",
        "No obligation",
        "You see the result first",
        "Designed specifically for your business",
        "Takes only a short consultation call",
      ],
      cta: "Your business – your website – your decision",
    },
    // Testimonials / Portfolio
    testimonials: {
      badge: "Our Portfolio",
      title: "Websites We've Built",
      subtitle: "Take a look at some of the websites we've created for our clients",
      visitSite: "Visit",
      viewAll: "View All Projects",
    },
    // Portfolio Page
    portfolio: {
      badge: "Complete Portfolio",
      title: "All Our Projects",
      subtitle: "Browse through our complete collection of websites we've built for businesses across different industries",
      backHome: "Back to Home",
      cta: {
        title: "Want to Be Our Next Success Story?",
        subtitle: "Let us create a stunning website for your business too.",
        button: "Get Started Today",
      },
    },
    // Packages
    packages: {
      title: "Our Packages",
      basic: {
        name: "BASIC",
        priceYear: {
          eu: "280 € / Year",
          tn: "850 TND / Year",
          gulf: "1000 SAR / Year",
        },
        subtitle: "Perfect for small local businesses",
        features: [
          "1–3 pages website",
          "Modern & clean design",
          "Mobile optimized",
          "Contact form",
          "Google Maps integration",
          "WhatsApp button",
          "Hosting included",
          "Maintenance included",
          "1 small change per month",
        ],
      },
      individual: {
        name: "INDIVIDUAL",
        price: {
          eu: "from 300 € / Year",
          tn: "from 900 TND / Year",
          gulf: "from 1100 SAR / Year",
        },
        subtitle: "Custom website based on your needs",
        cta: "Price after free consultation",
      },
    },
    // How It Works
    howItWorks: {
      title: "How It Works",
      steps: [
        {
          number: "1",
          title: "Contact Us",
          description: "You contact us or book a free consultation.",
        },
        {
          number: "2",
          title: "Demo Creation",
          description: "We create a demo website for your business.",
        },
        {
          number: "3",
          title: "Your Decision",
          description: "You decide if you want to continue – no pressure.",
        },
      ],
    },
    // Lead Form
    leadForm: {
      title: "Request Your Free Consultation",
      businessName: "Business Name",
      contactPerson: "Contact Person",
      phone: "Phone Number (WhatsApp preferred)",
      businessType: "Business Type",
      city: "City",
      message: "Short Message (optional)",
      submit: "Book Free Consultation",
      success: "Thank you! We will contact you soon.",
      error: "Something went wrong. Please try again.",
    },
    // Final CTA
    finalCta: {
      title: "Let's Talk About Your Website",
      description: "Book your free consultation now and see what your website could look like.",
      primaryBtn: "Book Free Consultation",
      secondaryBtn: "Request Free Demo Website",
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
    },
    // About Page
    about: {
      hero: {
        title: "About Us",
        subtitle: "We are a dedicated team of web professionals helping businesses establish their online presence with modern, affordable websites.",
      },
      mission: {
        title: "Our Mission",
        text1: "We believe every business deserves a professional online presence. Our mission is to make high-quality web design accessible and affordable for local businesses of all sizes.",
        text2: "From restaurants and cafes to shops and service providers – we help you reach more customers and grow your business through the power of the internet.",
        stat1: "Happy Businesses",
        stat2: "Years of Experience",
      },
      values: {
        title: "Our Values",
        subtitle: "The principles that guide everything we do",
        quality: {
          title: "Quality",
          desc: "We deliver professional, modern websites that make your business stand out.",
        },
        customer: {
          title: "Customer Focus",
          desc: "Your success is our success. We listen and adapt to your needs.",
        },
        innovation: {
          title: "Innovation",
          desc: "We use the latest technologies to give you a competitive edge.",
        },
        trust: {
          title: "Trust",
          desc: "No hidden fees, no pressure. See your website before you pay.",
        },
      },
      team: {
        title: "Meet Our Team",
        subtitle: "The people behind your success",
        ceo: "CEO & Founder",
        projectManager: "Project & Client Manager",
        marketing: "Marketing Manager",
        designer: "Lead Designer",
        developer: "Developer",
        amirDesc: "Amir founded Kaufmanns Consulting with a vision to help businesses thrive online.",
        emnaDesc: "Emna ensures every client gets personal attention and the perfect solution for their needs.",
        amalDesc: "Amal crafts marketing strategies that help our clients reach their target audience.",
        malekDesc: "Malek builds robust, modern websites with clean code and cutting-edge technologies.",
      },
      cta: {
        title: "Ready to Work With Us?",
        subtitle: "Let's create something amazing together. Contact us today for a free consultation.",
        button: "Get Started",
      },
    },
  },
  fr: {
    // Nav
    nav: {
      packages: "Forfaits",
      howItWorks: "Comment ça marche",
      contact: "Contact",
      about: "À Propos",
    },
    // Hero
    hero: {
      headline: "Obtenez un Site Web Professionnel pour Votre Entreprise",
      subheadline: "Nous créons des sites web modernes pour les entreprises locales – simples, abordables et sans risque.",
      cta: "Voyez votre site web avant de décider.",
      primaryBtn: "Demandez Votre Démo Gratuite",
      secondaryBtn: "Réservez une Consultation Gratuite",
      happyBusinesses: "Entreprises Satisfaites",
    },
    // Contact Person
    contactPerson: {
      title: "Votre Contact Personnel",
      name: "Emna Sayed",
      position: "Chef de Projet & Responsable Client",
      description: "Emna Sayed est votre interlocutrice directe. Elle vous expliquera tout personnellement et vous aidera à choisir la meilleure solution pour votre entreprise.",
    },
    // Lead Hook
    leadHook: {
      title: "Pourquoi Demander un Site Démo Gratuit?",
      badge: "Sans Risque",
      benefits: [
        "Aucun paiement initial",
        "Sans engagement",
        "Vous voyez le résultat d'abord",
        "Conçu spécifiquement pour votre entreprise",
        "Ne prend qu'un court appel de consultation",
      ],
      cta: "Votre entreprise – votre site web – votre décision",
    },
    // Testimonials / Portfolio
    testimonials: {
      badge: "Notre Portfolio",
      title: "Sites Web Que Nous Avons Créés",
      subtitle: "Découvrez quelques sites web que nous avons créés pour nos clients",
      visitSite: "Visiter",
      viewAll: "Voir Tous les Projets",
    },
    // Portfolio Page
    portfolio: {
      badge: "Portfolio Complet",
      title: "Tous Nos Projets",
      subtitle: "Parcourez notre collection complète de sites web créés pour des entreprises de différents secteurs",
      backHome: "Retour à l'Accueil",
      cta: {
        title: "Voulez-vous Être Notre Prochaine Réussite?",
        subtitle: "Laissez-nous créer un site web époustouflant pour votre entreprise aussi.",
        button: "Commencer Aujourd'hui",
      },
    },
    // Packages
    packages: {
      title: "Nos Forfaits",
      basic: {
        name: "BASIQUE",
        priceYear: {
          eu: "280 € / An",
          tn: "850 TND / An",
          gulf: "1000 SAR / An",
        },
        subtitle: "Parfait pour les petites entreprises locales",
        features: [
          "Site web de 1 à 3 pages",
          "Design moderne et épuré",
          "Optimisé pour mobile",
          "Formulaire de contact",
          "Intégration Google Maps",
          "Bouton WhatsApp",
          "Hébergement inclus",
          "Maintenance incluse",
          "1 petite modification par mois",
        ],
      },
      individual: {
        name: "INDIVIDUEL",
        price: {
          eu: "à partir de 300 € / An",
          tn: "à partir de 900 TND / An",
          gulf: "à partir de 1100 SAR / An",
        },
        subtitle: "Site web personnalisé selon vos besoins",
        cta: "Prix après consultation gratuite",
      },
    },
    // How It Works
    howItWorks: {
      title: "Comment Ça Marche",
      steps: [
        {
          number: "1",
          title: "Contactez-Nous",
          description: "Vous nous contactez ou réservez une consultation gratuite.",
        },
        {
          number: "2",
          title: "Création Démo",
          description: "Nous créons un site web démo pour votre entreprise.",
        },
        {
          number: "3",
          title: "Votre Décision",
          description: "Vous décidez si vous voulez continuer – sans pression.",
        },
      ],
    },
    // Lead Form
    leadForm: {
      title: "Demandez Votre Consultation Gratuite",
      businessName: "Nom de l'Entreprise",
      contactPerson: "Personne de Contact",
      phone: "Numéro de Téléphone (WhatsApp de préférence)",
      businessType: "Type d'Entreprise",
      city: "Ville",
      message: "Court Message (optionnel)",
      submit: "Réserver une Consultation Gratuite",
      success: "Merci! Nous vous contacterons bientôt.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
    },
    // Final CTA
    finalCta: {
      title: "Parlons de Votre Site Web",
      description: "Réservez votre consultation gratuite maintenant et voyez à quoi votre site web pourrait ressembler.",
      primaryBtn: "Réserver une Consultation Gratuite",
      secondaryBtn: "Demander un Site Démo Gratuit",
    },
    // Footer
    footer: {
      rights: "Tous droits réservés.",
    },
    // About Page
    about: {
      hero: {
        title: "À Propos de Nous",
        subtitle: "Nous sommes une équipe dédiée de professionnels du web qui aide les entreprises à établir leur présence en ligne avec des sites web modernes et abordables.",
      },
      mission: {
        title: "Notre Mission",
        text1: "Nous croyons que chaque entreprise mérite une présence en ligne professionnelle. Notre mission est de rendre le design web de haute qualité accessible et abordable pour les entreprises locales de toutes tailles.",
        text2: "Des restaurants et cafés aux boutiques et prestataires de services – nous vous aidons à atteindre plus de clients et à développer votre entreprise grâce à la puissance d'internet.",
        stat1: "Entreprises Satisfaites",
        stat2: "Années d'Expérience",
      },
      values: {
        title: "Nos Valeurs",
        subtitle: "Les principes qui guident tout ce que nous faisons",
        quality: {
          title: "Qualité",
          desc: "Nous livrons des sites web professionnels et modernes qui font ressortir votre entreprise.",
        },
        customer: {
          title: "Focus Client",
          desc: "Votre succès est notre succès. Nous écoutons et nous adaptons à vos besoins.",
        },
        innovation: {
          title: "Innovation",
          desc: "Nous utilisons les dernières technologies pour vous donner un avantage concurrentiel.",
        },
        trust: {
          title: "Confiance",
          desc: "Pas de frais cachés, pas de pression. Voyez votre site avant de payer.",
        },
      },
      team: {
        title: "Notre Équipe",
        subtitle: "Les personnes derrière votre succès",
        ceo: "PDG & Fondateur",
        projectManager: "Chef de Projet & Responsable Client",
        marketing: "Responsable Marketing",
        designer: "Designer Principal",
        developer: "Développeur",
        amirDesc: "Amir a fondé Kaufmanns Consulting avec la vision d'aider les entreprises à prospérer en ligne.",
        emnaDesc: "Emna s'assure que chaque client reçoit une attention personnelle et la solution parfaite pour ses besoins.",
        amalDesc: "Amal élabore des stratégies marketing qui aident nos clients à atteindre leur public cible.",
        malekDesc: "Malek construit des sites web robustes et modernes avec un code propre et des technologies de pointe.",
      },
      cta: {
        title: "Prêt à Travailler Avec Nous?",
        subtitle: "Créons ensemble quelque chose d'incroyable. Contactez-nous aujourd'hui pour une consultation gratuite.",
        button: "Commencer",
      },
    },
  },
  de: {
    // Nav
    nav: {
      packages: "Pakete",
      howItWorks: "So funktioniert's",
      contact: "Kontakt",
      about: "Über uns",
    },
    // Hero
    hero: {
      headline: "Holen Sie sich eine professionelle Website für Ihr Unternehmen",
      subheadline: "Wir erstellen moderne Websites für lokale Unternehmen – einfach, bezahlbar und ohne Risiko.",
      cta: "Sehen Sie Ihre Website, bevor Sie sich entscheiden.",
      primaryBtn: "Kostenlose Demo-Website anfordern",
      secondaryBtn: "Kostenlose Beratung buchen",
      happyBusinesses: "Zufriedene Unternehmen",
    },
    // Contact Person
    contactPerson: {
      title: "Ihre persönliche Ansprechpartnerin",
      name: "Emna Sayed",
      position: "Projekt- & Kundenmanagerin",
      description: "Emna Sayed ist Ihre direkte Ansprechpartnerin. Sie erklärt Ihnen alles persönlich und hilft Ihnen, die beste Lösung für Ihr Unternehmen zu wählen.",
    },
    // Lead Hook
    leadHook: {
      title: "Warum eine kostenlose Demo-Website anfordern?",
      badge: "Kein Risiko",
      benefits: [
        "Keine Vorauszahlung",
        "Keine Verpflichtung",
        "Sie sehen das Ergebnis zuerst",
        "Speziell für Ihr Unternehmen entworfen",
        "Erfordert nur ein kurzes Beratungsgespräch",
      ],
      cta: "Ihr Unternehmen – Ihre Website – Ihre Entscheidung",
    },
    // Testimonials / Portfolio
    testimonials: {
      badge: "Unser Portfolio",
      title: "Websites, die wir erstellt haben",
      subtitle: "Werfen Sie einen Blick auf einige der Websites, die wir für unsere Kunden erstellt haben",
      visitSite: "Besuchen",
      viewAll: "Alle Projekte ansehen",
    },
    // Portfolio Page
    portfolio: {
      badge: "Vollständiges Portfolio",
      title: "Alle unsere Projekte",
      subtitle: "Stöbern Sie durch unsere komplette Sammlung von Websites, die wir für Unternehmen verschiedener Branchen erstellt haben",
      backHome: "Zurück zur Startseite",
      cta: {
        title: "Möchten Sie unsere nächste Erfolgsgeschichte sein?",
        subtitle: "Lassen Sie uns auch für Ihr Unternehmen eine beeindruckende Website erstellen.",
        button: "Heute starten",
      },
    },
    // Packages
    packages: {
      title: "Unsere Pakete",
      basic: {
        name: "BASIC",
        priceYear: {
          eu: "280 € / Jahr",
          tn: "850 TND / Jahr",
          gulf: "1000 SAR / Jahr",
        },
        subtitle: "Perfekt für kleine lokale Unternehmen",
        features: [
          "Website mit 1–3 Seiten",
          "Modernes & klares Design",
          "Mobil optimiert",
          "Kontaktformular",
          "Google Maps Integration",
          "WhatsApp-Button",
          "Hosting inklusive",
          "Wartung inklusive",
          "1 kleine Änderung pro Monat",
        ],
      },
      individual: {
        name: "INDIVIDUELL",
        price: {
          eu: "ab 300 € / Jahr",
          tn: "ab 900 TND / Jahr",
          gulf: "ab 1100 SAR / Jahr",
        },
        subtitle: "Maßgeschneiderte Website nach Ihren Bedürfnissen",
        cta: "Preis nach kostenloser Beratung",
      },
    },
    // How It Works
    howItWorks: {
      title: "So funktioniert's",
      steps: [
        {
          number: "1",
          title: "Kontaktieren Sie uns",
          description: "Sie kontaktieren uns oder buchen eine kostenlose Beratung.",
        },
        {
          number: "2",
          title: "Demo-Erstellung",
          description: "Wir erstellen eine Demo-Website für Ihr Unternehmen.",
        },
        {
          number: "3",
          title: "Ihre Entscheidung",
          description: "Sie entscheiden, ob Sie weitermachen möchten – kein Druck.",
        },
      ],
    },
    // Lead Form
    leadForm: {
      title: "Fordern Sie Ihre kostenlose Beratung an",
      businessName: "Firmenname",
      contactPerson: "Ansprechpartner",
      phone: "Telefonnummer (WhatsApp bevorzugt)",
      businessType: "Geschäftsart",
      city: "Stadt",
      message: "Kurze Nachricht (optional)",
      submit: "Kostenlose Beratung buchen",
      success: "Vielen Dank! Wir werden uns bald bei Ihnen melden.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    },
    // Final CTA
    finalCta: {
      title: "Lassen Sie uns über Ihre Website sprechen",
      description: "Buchen Sie jetzt Ihre kostenlose Beratung und sehen Sie, wie Ihre Website aussehen könnte.",
      primaryBtn: "Kostenlose Beratung buchen",
      secondaryBtn: "Kostenlose Demo-Website anfordern",
    },
    // Footer
    footer: {
      rights: "Alle Rechte vorbehalten.",
    },
    // About Page
    about: {
      hero: {
        title: "Über uns",
        subtitle: "Wir sind ein engagiertes Team von Web-Profis, das Unternehmen hilft, mit modernen, bezahlbaren Websites online präsent zu sein.",
      },
      mission: {
        title: "Unsere Mission",
        text1: "Wir glauben, dass jedes Unternehmen eine professionelle Online-Präsenz verdient. Unsere Mission ist es, hochwertiges Webdesign für lokale Unternehmen jeder Größe zugänglich und bezahlbar zu machen.",
        text2: "Von Restaurants und Cafés bis hin zu Geschäften und Dienstleistern – wir helfen Ihnen, mehr Kunden zu erreichen und Ihr Unternehmen durch die Kraft des Internets zu vergrößern.",
        stat1: "Zufriedene Unternehmen",
        stat2: "Jahre Erfahrung",
      },
      values: {
        title: "Unsere Werte",
        subtitle: "Die Prinzipien, die alles leiten, was wir tun",
        quality: {
          title: "Qualität",
          desc: "Wir liefern professionelle, moderne Websites, die Ihr Unternehmen hervorheben.",
        },
        customer: {
          title: "Kundenfokus",
          desc: "Ihr Erfolg ist unser Erfolg. Wir hören zu und passen uns Ihren Bedürfnissen an.",
        },
        innovation: {
          title: "Innovation",
          desc: "Wir nutzen modernste Technologien, um Ihnen einen Wettbewerbsvorteil zu verschaffen.",
        },
        trust: {
          title: "Vertrauen",
          desc: "Keine versteckten Gebühren, kein Druck. Sehen Sie Ihre Website, bevor Sie zahlen.",
        },
      },
      team: {
        title: "Lernen Sie unser Team kennen",
        subtitle: "Die Menschen hinter Ihrem Erfolg",
        ceo: "CEO & Gründer",
        projectManager: "Projekt- & Kundenmanagerin",
        marketing: "Marketing-Managerin",
        designer: "Lead Designer",
        developer: "Entwickler",
        amirDesc: "Amir gründete Kaufmanns Consulting mit der Vision, Unternehmen zum Erfolg im Internet zu verhelfen.",
        emnaDesc: "Emna sorgt dafür, dass jeder Kunde persönliche Aufmerksamkeit und die perfekte Lösung für seine Bedürfnisse erhält.",
        amalDesc: "Amal entwickelt Marketingstrategien, die unseren Kunden helfen, ihre Zielgruppe zu erreichen.",
        malekDesc: "Malek baut robuste, moderne Websites mit sauberem Code und modernsten Technologien.",
      },
      cta: {
        title: "Bereit, mit uns zusammenzuarbeiten?",
        subtitle: "Lassen Sie uns gemeinsam etwas Großartiges schaffen. Kontaktieren Sie uns noch heute für eine kostenlose Beratung.",
        button: "Loslegen",
      },
    },
  },
  ar: {
    // Nav
    nav: {
      packages: "الباقات",
      howItWorks: "كيف يعمل",
      contact: "اتصل بنا",
      about: "من نحن",
    },
    // Hero
    hero: {
      headline: "احصل على موقع ويب احترافي لعملك",
      subheadline: "نقوم بإنشاء مواقع ويب حديثة للشركات المحلية – بسيطة وبأسعار معقولة وبدون مخاطر.",
      cta: "شاهد موقعك قبل أن تقرر.",
      primaryBtn: "اطلب عرضك التجريبي المجاني",
      secondaryBtn: "احجز استشارة مجانية",
      happyBusinesses: "شركة سعيدة",
    },
    // Contact Person
    contactPerson: {
      title: "جهة الاتصال الشخصية الخاصة بك",
      name: "إيمنة سيد",
      position: "مديرة المشاريع وعلاقات العملاء",
      description: "إيمنة سيد هي جهة الاتصال المباشرة الخاصة بك. ستشرح لك كل شيء شخصياً وتساعدك في اختيار أفضل حل لعملك.",
    },
    // Lead Hook
    leadHook: {
      title: "لماذا تطلب موقع ويب تجريبي مجاني؟",
      badge: "بدون مخاطر",
      benefits: [
        "لا دفع مقدم",
        "لا التزام",
        "ترى النتيجة أولاً",
        "مصمم خصيصاً لعملك",
        "يستغرق فقط مكالمة استشارية قصيرة",
      ],
      cta: "عملك – موقعك – قرارك",
    },
    // Testimonials / Portfolio
    testimonials: {
      badge: "أعمالنا",
      title: "مواقع قمنا بإنشائها",
      subtitle: "ألقِ نظرة على بعض المواقع التي أنشأناها لعملائنا",
      visitSite: "زيارة",
      viewAll: "عرض جميع المشاريع",
    },
    // Portfolio Page
    portfolio: {
      badge: "المحفظة الكاملة",
      title: "جميع مشاريعنا",
      subtitle: "تصفح مجموعتنا الكاملة من المواقع التي أنشأناها للشركات في مختلف الصناعات",
      backHome: "العودة للرئيسية",
      cta: {
        title: "هل تريد أن تكون قصة نجاحنا القادمة؟",
        subtitle: "دعنا نصمم موقعاً مذهلاً لعملك أيضاً.",
        button: "ابدأ اليوم",
      },
    },
    // Packages
    packages: {
      title: "باقاتنا",
      basic: {
        name: "الأساسية",
        priceYear: {
          eu: "280 € / سنة",
          tn: "850 دينار / سنة",
          gulf: "1000 ريال / سنة",
        },
        subtitle: "مثالي للشركات المحلية الصغيرة",
        features: [
          "موقع من 1-3 صفحات",
          "تصميم عصري ونظيف",
          "محسّن للجوال",
          "نموذج اتصال",
          "تكامل خرائط جوجل",
          "زر واتساب",
          "استضافة مضمنة",
          "صيانة مضمنة",
          "تغيير صغير واحد شهرياً",
        ],
      },
      individual: {
        name: "مخصص",
        price: {
          eu: "ابتداءً من 300 € / سنة",
          tn: "ابتداءً من 900 دينار / سنة",
          gulf: "ابتداءً من 1100 ريال / سنة",
        },
        subtitle: "موقع ويب مخصص حسب احتياجاتك",
        cta: "السعر بعد الاستشارة المجانية",
      },
    },
    // How It Works
    howItWorks: {
      title: "كيف يعمل",
      steps: [
        {
          number: "1",
          title: "اتصل بنا",
          description: "تواصل معنا أو احجز استشارة مجانية.",
        },
        {
          number: "2",
          title: "إنشاء العرض التجريبي",
          description: "نقوم بإنشاء موقع ويب تجريبي لعملك.",
        },
        {
          number: "3",
          title: "قرارك",
          description: "أنت تقرر إذا كنت تريد المتابعة – بدون ضغط.",
        },
      ],
    },
    // Lead Form
    leadForm: {
      title: "اطلب استشارتك المجانية",
      businessName: "اسم العمل",
      contactPerson: "الشخص المسؤول",
      phone: "رقم الهاتف (واتساب مفضل)",
      businessType: "نوع العمل",
      city: "المدينة",
      message: "رسالة قصيرة (اختياري)",
      submit: "احجز استشارة مجانية",
      success: "شكراً! سنتواصل معك قريباً.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    },
    // Final CTA
    finalCta: {
      title: "لنتحدث عن موقعك",
      description: "احجز استشارتك المجانية الآن وشاهد كيف يمكن أن يبدو موقعك.",
      primaryBtn: "احجز استشارة مجانية",
      secondaryBtn: "اطلب موقع تجريبي مجاني",
    },
    // Footer
    footer: {
      rights: "جميع الحقوق محفوظة.",
    },
    // About Page
    about: {
      hero: {
        title: "من نحن",
        subtitle: "نحن فريق متخصص من محترفي الويب نساعد الشركات في إنشاء حضورها على الإنترنت بمواقع ويب حديثة وبأسعار معقولة.",
      },
      mission: {
        title: "مهمتنا",
        text1: "نؤمن بأن كل شركة تستحق حضوراً مهنياً على الإنترنت. مهمتنا هي جعل تصميم الويب عالي الجودة متاحاً وبأسعار معقولة للشركات المحلية من جميع الأحجام.",
        text2: "من المطاعم والمقاهي إلى المتاجر ومقدمي الخدمات – نساعدك في الوصول إلى المزيد من العملاء وتنمية عملك من خلال قوة الإنترنت.",
        stat1: "شركة سعيدة",
        stat2: "سنوات من الخبرة",
      },
      values: {
        title: "قيمنا",
        subtitle: "المبادئ التي توجه كل ما نقوم به",
        quality: {
          title: "الجودة",
          desc: "نقدم مواقع ويب احترافية وحديثة تجعل عملك يبرز.",
        },
        customer: {
          title: "التركيز على العميل",
          desc: "نجاحك هو نجاحنا. نستمع ونتكيف مع احتياجاتك.",
        },
        innovation: {
          title: "الابتكار",
          desc: "نستخدم أحدث التقنيات لنمنحك ميزة تنافسية.",
        },
        trust: {
          title: "الثقة",
          desc: "لا رسوم خفية، لا ضغط. شاهد موقعك قبل أن تدفع.",
        },
      },
      team: {
        title: "تعرف على فريقنا",
        subtitle: "الأشخاص وراء نجاحك",
        ceo: "المدير التنفيذي والمؤسس",
        projectManager: "مديرة المشاريع وعلاقات العملاء",
        marketing: "مديرة التسويق",
        designer: "المصممة الرئيسية",
        developer: "مطور",
        amirDesc: "أسس أمير كاوفمانز للاستشارات برؤية لمساعدة الشركات على الازدهار عبر الإنترنت.",
        emnaDesc: "تضمن إيمنة أن يحصل كل عميل على اهتمام شخصي والحل الأمثل لاحتياجاته.",
        amalDesc: "تصمم أمل استراتيجيات تسويقية تساعد عملاءنا في الوصول إلى جمهورهم المستهدف.",
        malekDesc: "يبني مالك مواقع ويب قوية وحديثة بكود نظيف وتقنيات متطورة.",
      },
      cta: {
        title: "هل أنت مستعد للعمل معنا؟",
        subtitle: "لنبدع شيئاً مذهلاً معاً. اتصل بنا اليوم للحصول على استشارة مجانية.",
        button: "ابدأ الآن",
      },
    },
  },
};
